import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { useTranslation } from "@/i18n";

const faqKeys = [
   "improveSeoWoo",
   "aiForSeo",
   "replacesYoast",
   "howLong",
  "aiWorks",
  "needSeoKnowledge",
  "wooCompatible",
  "reviewBefore",
  "freeProducts",
  "uniqueContent",
  "dontLike",
  "cancel",
];

const FAQ = () => {
  const { t } = useTranslation();

  return (
    <section id="faq" className="py-20 md:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="glow-orb glow-orb-primary w-[500px] h-[500px] bottom-0 left-0 opacity-15" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-card text-sm font-medium mb-6">
            <HelpCircle size={16} className="text-primary" />
            <span className="text-foreground">{t('faq.badge')}</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-lg text-muted-foreground">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqKeys.map((key, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="glass-card rounded-2xl border border-border/30 px-6 data-[state=open]:shadow-glow transition-all duration-300 overflow-hidden"
              >
                <AccordionTrigger className="text-left text-foreground hover:no-underline py-6 font-semibold text-base">
                  {t(`faq.items.${key}.question`)}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                  {t(`faq.items.${key}.answer`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
